<div class="fundo">
<div align="center">
  MANTER MÁQUINA
</div>
</div>